export const LOADING = 'LOADING'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_EMAIL_ADDRESES = 'SET_EMAIL_ADDRESES'
export const SET_SELECTED_MESSAGE = 'SET_SELECTED_MESSAGE'
export const SET_SELECTED_DOCUMENT = 'SET_SELECTED_DOCUMENT'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_ERROR = 'SET_ERROR'
export const SET_SELECTEDCLAIM_ATTACHMENTS = 'SET_SELECTEDCLAIM_ATTACHMENTS'
export const SET_CLAIM_MESSAGES_UNREAD = 'SET_CLAIM_MESSAGES_UNREAD'
export const SET_MESSAGE_PREVIEW = 'SET_MESSAGE_PREVIEW'
export const SET_DOCUMENT_TYPES = 'SET_DOCUMENT_TYPES'
export const UPDATE_SELECTEDCLAIM_ATTACHMENT = 'UPDATE_SELECTEDCLAIM_ATTACHMENT'
export const SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT = 'SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT'